<div class="profileImage" [ngClass]="{'has-image': (userProfile | async)?.profile_image_url}" *ngIf="(userProfile | async)?.profile_image_url">
  <img
    appDisableRightClick
    appMobileOptimization
    [originalUrl]="(userProfileData?.delegate_user?.sk && isHeader ? userProfileData.delegate_user : userProfileData)?.profile_image_url"
    [src]="
      (userProfileData?.delegate_user?.sk && isHeader
        ? userProfileData.delegate_user
        : userProfileData
      )?.profile_image_url
    "
    [format]="'webp'"
    alt="Profile Image"
    loading="lazy"
    decoding="async"
  />
</div>
